import React from 'react';
import axios from 'axios';
import { env } from 'env.mjs';

import useUserStore from '@/utils/store/store';
import { useWebSocketNotificationsStore } from '@/components/common/WebNotifications/store';

const useGetAllNotification = () => {
  const { setMessages } = useWebSocketNotificationsStore();
  const { user } = useUserStore();

  const userAuthString = localStorage.getItem('userauth');
  const userAuthObject = JSON.parse(userAuthString || '{}');
  const client = {
    codeClient: env.NEXT_PUBLIC_CODE_CLIENT,
    productCode: env.NEXT_PUBLIC_PRODUCT_CODE,
    userEmail: userAuthObject?.email,
  };
  const generateBaseUrl = `${client.codeClient};${client.productCode};${client.userEmail}`;
  const base64Url = btoa(generateBaseUrl);
  const apiUrl = `${env.NEXT_PUBLIC_SOCKET_URL}${env.NEXT_PUBLIC_ALERTS_URL}${base64Url}`;

  const getAllNotifications = async () => {
    try {
      const response = await axios.get(apiUrl);

      setMessages(response.data);
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
    }
  };

  return { getAllNotifications };
};

export default useGetAllNotification;
